import React from 'react';
import { Package } from 'lucide-react';
interface ProductPlaceholderProps {
  className?: string;
  aspectRatio?: '1/1' | '4/3' | '3/2';
}
export function ProductPlaceholder({
  className = '',
  aspectRatio = '1/1'
}: ProductPlaceholderProps) {
  const aspectClasses = {
    '1/1': 'aspect-square',
    '4/3': 'aspect-[4/3]',
    '3/2': 'aspect-[3/2]'
  };
  return <div className={`bg-slate-100 flex flex-col items-center justify-center border border-steel-200 ${aspectClasses[aspectRatio]} ${className}`} data-id="element-261">
      <Package className="w-8 h-8 text-steel-300 mb-2" strokeWidth={1.5} data-id="element-262" />
      <span className="text-[10px] font-medium text-steel-400 uppercase tracking-wider" data-id="element-263">
        Product Image
      </span>
    </div>;
}